import { EventCategory as EventCategoryDto, TaskDefaults as TaskDefaultsDto } from "./client";
import { TaskDefaults } from "./Tasks";
import { Category, PrimaryCategory } from "./EventMetaTypes";
import { PriorityLevel } from "./Events";

export const dtoToCategory = (dto: EventCategoryDto): Category => PrimaryCategory.get(dto as string);

export const dtoToTaskDefaults = (dto: TaskDefaultsDto): TaskDefaults => ({
  ...dto,
  category: dtoToCategory(dto.category as EventCategoryDto),
  priority: dto.priority as PriorityLevel, // TODO: Backend needs to use PriorityLevel instead of String for this field
});
